module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rp-modal-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.$bus.$emit('closeModal')
      }
    }
  }, [_c('div', {
    staticClass: "rp-modal"
  }, [_c('div', {
    staticClass: "rp-modal-header"
  }, [_c('div', {
    staticClass: "rp-rcontrols"
  }, [_c('a', {
    staticClass: "icon-times",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.$bus.$emit('closeModal')
      }
    }
  })]), _vm._v(" "), _c('h4', [_vm._v("Project Settings")])]), _vm._v(" "), _c('div', {
    staticClass: "rp-modal-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-3",
    attrs: {
      "for": "projectName"
    }
  }, [_vm._v("Project Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "projectName"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-3",
    attrs: {
      "for": "projectDescription"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "projectDescription",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "rp-modal-buttons clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.$bus.$emit('closeModal')
      }
    }
  }, [_vm._v("Cancel")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('a', {
    staticClass: "rp-modal-buttons-text",
    attrs: {
      "href": "https://en.wikipedia.org/wiki/Markdown",
      "target": "_blank"
    }
  }, [_vm._v("Markdown supported")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e86c5dce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/InfoEditor.vue
// module id = 486
// module chunks = 0